import { render, staticRenderFns } from "./municipality-message-edit.vue?vue&type=template&id=58e51c43&"
import script from "./municipality-message-edit.vue?vue&type=script&lang=js&"
export * from "./municipality-message-edit.vue?vue&type=script&lang=js&"
import style0 from "./municipality-message-edit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports